var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0 route-view-card fill-height",attrs:{"fluid":""}},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#00A5A2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }